const MinimizedObjectSection = ({
  title,
  type,
  items,
  isOpened,
  toggleHandler,
  maximizeModal,
  closeAllModals,
  closeItemModal,
  getItemLabel,
  itemKey = "id", // fallback key
  expandIcon,
  closeIcon,
  containerWidthClass
}) => {
  return (
    <div className="minimized-objects-row-wrapper">
      {isOpened && items.length > 0 && (
        <div
          className={`minimized-objects-expanded-view ${containerWidthClass}`}
        >
          <div className="minimized-objects-expanded-view-header">
            <span className="minimized-objects-expanded-view-header-title">
              {title}
            </span>
            <span
              onClick={() => closeAllModals(type)}
              className="minimized-objects-expanded-view-header-close"
            >
              Close All
            </span>
          </div>
          <div className="minimized-objects-expanded-view-body">
            {items.map((item, index) => (
              <div
                key={item[itemKey] ?? index}
                className="minimized-objects-expanded-view-body-item"
                onClick={() => maximizeModal(item, type)}
              >
                <span>{getItemLabel(item)}</span>
                <div className="object-items-actions-buttons-container">
                  <p className="minimize-card-container-toggler">
                    <img src={expandIcon} alt="expand_icon" />
                  </p>
                  <p
                    onClick={(e) => {
                      e.stopPropagation();
                      closeItemModal(item);
                    }}
                    className="minimize-card-container-toggler margin-left-5"
                  >
                    <img
                      className="minimize-card-img"
                      src={closeIcon}
                      alt="close_icon"
                    />
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {items.length > 0 && (
        <div onClick={toggleHandler} className="minimize-card-container">
          <p className="minimize-card-container-title">{title}</p>
          <div className="minimize-card-container-count-container">
            <p className="minimize-card-container-count">{items.length}</p>
          </div>
          <p className="minimize-card-container-toggler">
            <img
              className={`${
                isOpened
                  ? "rotate-down-arrow-on-click"
                  : "rotate-up-arrow-on-click"
              }`}
              src={expandIcon}
              alt="arrow_icon"
            />
          </p>
        </div>
      )}
    </div>
  );
};

export default MinimizedObjectSection;
